export const SCORE_PRECISION = 2;

export const MOS_MIN_VAL = 1;
export const MOS_MAX_VAL = 5;

export const MS_IN_SEC = 1000;

export const INBOUND_Q_PERCENTILE = 0.5;
